exports.componentPropsPlugin = require('../lib/next-config/plugins/component-props');
exports.corsHeaderPlugin = require('../lib/next-config/plugins/cors-header');
exports.feaasPlugin = require('../lib/next-config/plugins/feaas');
exports.graphqlPlugin = require('../lib/next-config/plugins/graphql');
exports.robotsPlugin = require('../lib/next-config/plugins/robots');
exports.rssPlugin = require('../lib/next-config/plugins/rss');
exports.sitemapPlugin = require('../lib/next-config/plugins/sitemap');
